"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhooksModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const webhooks_controller_1 = require("./webhooks.controller");
const notifications_module_1 = require("../notifications/notifications.module");
const customers_module_1 = require("../customers/customers.module");
/**
 * Handles all inbound delivery-status callbacks and customer replies
 * from Twilio, Meta WhatsApp, and SendGrid.
 *
 * All routes under /api/webhooks/* are PUBLIC — providers post here directly.
 * Security is enforced via per-route signature guards (TwilioSignatureGuard,
 * WhatsappSignatureGuard) rather than JWT.
 */
let WebhooksModule = class WebhooksModule {
};
exports.WebhooksModule = WebhooksModule;
exports.WebhooksModule = WebhooksModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [notifications_module_1.NotificationsModule, customers_module_1.CustomersModule],
        controllers: [webhooks_controller_1.WebhooksController],
    })
], WebhooksModule);
